<template>
  <AnimationLoading
    v-if="store.activatingTrial"
  />
  <StepContainer
    :step-list="stepList"
    track-history
  />
</template>

<script setup>
import StepContainer from "../components/StepContainer.vue";
import StepCompanyCreate2 from "../components/StepCompanyCreate2.vue";
import StepCompanyCreate3 from "../components/StepCompanyCreate3.vue";
import StepCompanyCreate4 from "../components/StepCompanyCreate4.vue";
import StepCompanyCreate5 from "../components/StepCompanyCreate5.vue";
import StepCompanyCreate6 from "../components/StepCompanyCreate6.vue";
import StepCompanyCreate7 from "../components/StepCompanyCreate7.vue";
import StepCompanyCreate8 from "../components/StepCompanyCreate8.vue";
import {useCompanyAccountCreateStore} from "../stores/CompanyAccountCreateStore.js";
import {ABANDONED_SIGN_UP_MODEL_COMPANY, useAbandonedSignUp} from "../composables/AbandonedSignUp";
import {onBeforeUnmount, provide} from "vue";
import {useRoute} from "vue-router";
import AnimationLoading from "../components/AnimationLoading.vue";
import StepTeamMemberAddCalendar from "../components/StepTeamMemberAddCalendar.vue";

const stepList = [
  StepCompanyCreate2,
  StepCompanyCreate3,
  StepCompanyCreate4,
  StepCompanyCreate5,
  StepCompanyCreate6,
  StepCompanyCreate7,
  StepTeamMemberAddCalendar,
  StepCompanyCreate8,
];

const route = useRoute();

const store = useCompanyAccountCreateStore();
store.handleCheckoutUuid();
store.handleActivateTrial(route.query.token);

const {
  manuallyTrigger,
  manuallyStart,
  manuallyCancel,
} = useAbandonedSignUp(ABANDONED_SIGN_UP_MODEL_COMPANY, useCompanyAccountCreateStore);

provide("manuallyTriggerAbandonedSignUp", manuallyTrigger);
provide("manuallyStartAbandonedSignUp", manuallyStart);
provide("manuallyCancelAbandonedSignUp", manuallyCancel);

onBeforeUnmount(() => manuallyCancel());
</script>
